/* LAYOUT COMPONENTS */
import Header from "./header";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  // Handle responsive sidebar
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsMobile(true);
        setIsSidebarOpen(false);
      } else {
        setIsMobile(false);
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <section className="bg-body">
      <div className="flex h-screen">
        {/* Sidebar */}
        <Sidebar
          isOpen={isSidebarOpen}
          isMobile={isMobile}
          toggleSidebar={toggleSidebar}
        />

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0">
          <div className="px-4 py-3 flex-shrink-0">
            <Header toggleSidebar={toggleSidebar} />
          </div>
          <div className="flex-1 overflow-auto hide-scrollbar p-4">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Layout;
